// acts as a single source of truth for gathering variables from your HTML form fields, 
//replacing messy inline extraction code.

/* ==========================================================================
   MODULE 1: FORM EXTRACTOR (formExtractor.js)
   ========================================================================== */
import { capitalizeAndLowercaseRest, calculateAge } from './supportFuncs';
import { getSelectedRaceEthnicity } from './studentInfo';

export function extractCurrentFormDataPayload() {
  const birthMonth = document.getElementById('birthMonth')?.value || '01';
  const birthDay = document.getElementById('birthDay')?.value || '01';
  const birthYear = document.getElementById('birthYear')?.value || '2000';
  const dobString = `${birthMonth}-${birthDay}-${birthYear}`;
  
  const studentSchool = document.getElementById('studentSchool')?.value || '';
  const studentSchoolOther = document.getElementById('studentSchoolOther')?.value || '';
  const finalSchoolVal = studentSchool === 'Other' ? studentSchoolOther.trim() : studentSchool;

  const studentGender = document.getElementById('studentGender')?.value || '';
  const studentGenderCustom = document.getElementById('studentGenderCustom')?.value || '';
  const finalGenderVal = studentGender === 'Prefer to self-describe' ? studentGenderCustom.trim() : studentGender;

  const parentRelation = document.getElementById('parentRelation')?.value || '';
  const parentRelationOther = document.getElementById('parentRelationOther')?.value || '';
  const finalParentRelationVal = parentRelation === 'Other' ? parentRelationOther.trim() : parentRelation;

  const emergRelation = document.getElementById('emergRelation')?.value || '';
  const emergRelationOther = document.getElementById('emergRelationOther')?.value || '';
  const finalEmergRelationVal = emergRelation === 'Other' ? emergRelationOther.trim() : emergRelation;

  const secondParentRelation = document.getElementById('secondParentRelation')?.value || '';
  const secondParentRelationOther = document.getElementById('secondParentRelationOther')?.value || '';
  const finalSecondRelationVal = secondParentRelation === 'Other' ? secondParentRelationOther.trim() : secondParentRelation;

  // Gather parent checkbox dates strings cleanly
  const parent1Boxes = Array.from(document.querySelectorAll('input[name="parent1ClassDates"]:checked'));
  const parent1Dates = parent1Boxes.map(cb => cb.value).join(', ');

  const parent2Boxes = Array.from(document.querySelectorAll('input[name="parent2ClassDates"]:checked'));
  const parent2Dates = parent2Boxes.map(cb => cb.value).join(', ');

  const payload = {
    student: {
      session1: document.getElementById('session1')?.checked ? 1 : 0,
      session2: document.getElementById('session2')?.checked ? 1 : 0,
      session3: document.getElementById('session3')?.checked ? 1 : 0,
      session4: document.getElementById('session4')?.checked ? 1 : 0,
      studentType: document.getElementById('studentType')?.value || '1',
      studentFName: capitalizeAndLowercaseRest(document.getElementById('studentFName')?.value || '').trim(),
      studentLName: capitalizeAndLowercaseRest(document.getElementById('studentLName')?.value || '').trim(),
      studentSuffix: document.getElementById('studentSuffix')?.value || '',
      studentGrade: document.getElementById('studentGrade')?.value || '',
      studentSchool: finalSchoolVal,
      schoolDistrict: window.schoolDistrict || 0,
      studentRace: getSelectedRaceEthnicity().join(', '),
      studentGender: finalGenderVal,
      studentDOB: dobString,
      studentAge: calculateAge(dobString),
      studentZip: (document.getElementById('studentZip')?.value || '').trim(),
      studentNeedsLaptop: document.getElementById('studentLaptop')?.value || '0'
    },
    parentGuardian: {
      parentFName: capitalizeAndLowercaseRest(document.getElementById('parentFName')?.value || '').trim(),
      parentLName: capitalizeAndLowercaseRest(document.getElementById('parentLName')?.value || '').trim(),
      parentRelation: finalParentRelationVal,
      parentPhone: (document.getElementById('parentPhone')?.value || '').trim(),
      parentEmail: (document.getElementById('parentEmail')?.value || '').trim(),
      parentAttendance: document.getElementById('parentAttendingBeginner')?.value || 'No',
      parentAttending: ['Same Parent', 'Different Parent', 'Two Parents'].includes(document.getElementById('parentAttendingBeginner')?.value),
      parent1SessionDates: parent1Dates,
      parent1NeedsLaptop: document.getElementById('parent1Laptop')?.value || '0',
      parent2FName: capitalizeAndLowercaseRest(document.getElementById('secondParentFirstName')?.value || '').trim(),
      parent2LName: capitalizeAndLowercaseRest(document.getElementById('secondParentLastName')?.value || '').trim(),
      secondParentRelation: finalSecondRelationVal,
      parent2SessionDates: parent2Dates,
      parent2NeedsLaptop: document.getElementById('parent2Laptop')?.value || '0'
    },
    emergencyContact: {
      emergFName: capitalizeAndLowercaseRest(document.getElementById('emergFName')?.value || '').trim(),
      emergLName: capitalizeAndLowercaseRest(document.getElementById('emergLName')?.value || '').trim(),
      emergRelation: finalEmergRelationVal,
      emergPhone: (document.getElementById('emergPhone')?.value || '').trim()
    },
    medical: {
      medIssues: document.getElementById('medIssues')?.value || 'No',
      explainMed: (document.getElementById('explainMed')?.value || '').trim(),
      allergies: document.getElementById('allergies')?.value || 'No',
      explainAllergies: (document.getElementById('explainAllergy')?.value || '').trim(),
      hospital: (document.getElementById('hospital')?.value || '').trim()
    },
    consentAndSignatures: {
      signerName: (document.getElementById('signerName')?.value || '').trim(),
      readPolicies: document.getElementById('policies')?.value || 'No'
    }
  };

  console.log('[Extractor Engine] Processed master registration Payload object layout:', payload);
  return payload;
}
